module.exports = __webpack_public_path__ + "static/media/runningTasks.d6d96ba7.svg";